<template>
    <b-card header="Almacenamiento de productos químicos - Diseño de matriz de compatibilidad"
            header-class="font-weight-bold"
    >
        <b-row >
            <div class="form-group col-md-4" v-if="this.validarPermisoComponente('matriz-compatibilidad-almacenamiento')">
                <label for="id_empresa">
                    Empresa
                </label>
                <el-select v-model="filtros.id_empresa"
                           id="id_empresa"
                           name="id_empresa"
                           filterable
                           remote
                           size="small"
                            @change="onChangeEmpresa"
                           placeholder="Seleccione una empresa"
                           no-data-text="No hay datos que coincidan"
                           no-match-text="No hay datos que coincidan"
                           :remote-method="obtenerEmpresasFiltro"
                >
                    <el-option v-for="empresa in empresas_filtro"
                               :key="empresa.id"
                               :label="empresa.nombre"
                               :value="empresa.id"
                    />
                </el-select>
            </div>

            <div class="form-group col-md-4">
                <label for="id_ubicacion">
                    Ubicación
                </label>
                <tree-select :value="filtros.id_ubicacion"
                             class="text-uppercase"
                             :multiple="false"
                             :defaultExpandLevel="Infinity"
                             :options="ubicaciones_filtro"
                             :disabled="!filtros.id_empresa"
                             @input="establecerIdUbicacionFiltro"
                />
            </div>

            <div class="form-group col-md-4">
                <label class="w-100">&nbsp;</label>
                <b-button variant="primary"
                          class="mx-1"
                          @click.prevent="obtenerComparaciones()"
                          :disabled="!filtros.id_empresa"
                          size="small"
                >
                    <i class="fa fa-search fa-lg"/>
                    <span class="d-none d-md-inline-block"
                          v-text="'Buscar'"
                    />
                </b-button>
                <b-button @click="limpiarFiltro()"
                          :disabled="!filtros.id_empresa"
                          class="mx-1"
                >
                    <i class="fa fa-eraser fa-lg"/>
                    <span class="d-none d-md-inline-block"
                          v-text="'Limpiar'"
                    />
                </b-button>

                <b-button variant="primary"
                          class="float-right"
                          to="/matriz-compatibilidad/almacenamiento/formulario"
                          v-text="'Nuevo'"
                />
            </div>

            <div class="form-group col-md-6">
                <b-button
                        :variant="!filtros.id_empresa ? 'secondary' :'primary'"
                        :disabled="!filtros.id_empresa"
                        @click="descargarExcelGenerico(filtros.id_empresa)"
                >
                    <i class="fa fa-file-excel-o"></i>
                    Descargar Matriz Generica
                </b-button>
            </div>

        </b-row>
        <b-table class="mt-3"
                 responsive
                 striped
                 hover
                 :items="comparaciones.data"
                 :fields="columnas"
                 empty-text="No hay registros para mostrar"
                 show-empty
        >
            <template v-slot:cell(actions)="data">

                <b-button variant="danger"
                          size="sm"
                          v-b-tooltip.hover
                          title="Eliminar"
                          class="float-right mx-1"
                          @click="eliminarComparacion(data.item)"
                >
                    <i class="fa fa-trash"></i>
                </b-button>

                <router-link v-b-tooltip.hover
                             title="Editar"
                             class="btn btn-sm btn-primary float-right mx-1"
                             :to="`/matriz-compatibilidad/almacenamiento/formulario/${data.item.id}/${data.item.id_empresa}`"
                >
                    <i class="fa fa-edit"/>
                </router-link>

                <b-button :variant="!data.item.matriz_compatibilidad_productos_count ? 'secondary' :'success'"
                          size="sm"
                          v-b-tooltip.hover
                          title="Descargar matriz"
                          class="float-right mx-1"
                          :disabled="!data.item.matriz_compatibilidad_productos_count"
                          @click="actionDescargarExcel(data.item)"
                >
                    <i class="fa fa-file-excel-o"></i>
                </b-button>
            </template>
        </b-table>

        <!-- Paginación -->
        <el-pagination v-if="comparaciones.data && !!comparaciones.data.length"
                       v-model="filtros.page"
                       @size-change="obtenerComparaciones()"
                       @current-change="obtenerComparaciones()"
                       :current-page.sync="filtros.page"
                       class="float-right"
                       :page-size.sync="filtros.perPage"
                       :page-sizes="[10, 30, 50, 100]"
                       layout="total, sizes, prev, pager, next"
                       :total="comparaciones.total"
        />
        
        <LoadingCompatibility :loading="initloading" :title="title" :message="message" />
    </b-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import TreeSelect from '@riophae/vue-treeselect';
import LoadingCompatibility from './LoadingCompatibility.vue';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
    // obtener comparaciones al cargar el componente
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (to.query.reload) {
                vm.obtenerComparaciones();
            }
        });
    },
    name: 'index',
    components: {
        TreeSelect,
        LoadingCompatibility
    },
    data() {
        return {
            reset: false,
            columnas: [
                {
                    key: 'fecha',
                    label: 'Fecha',
                    sortable: false
                },
                {
                    key: 'empresa.nombre',
                    label: 'Empresa',
                    sortable: false
                },
                {
                    key: 'ubicacion.description',
                    label: 'Ubicación',
                    sortable: false
                },
                {
                    key: 'descripcion',
                    label: 'Descripción',
                    sortable: false
                },
                {
                    key: 'matriz_compatibilidad_productos_count',
                    label: 'Cant productos',
                    tdClass: 'text-center',
                    thClass: 'text-center',
                    sortable: false
                },
                {
                    key: 'actions',
                    tdClass: 'text-center',
                    thClass: 'text-center',
                    label: 'Opciones'
                }
            ],
            validarPermisoComponente: validarPermisoComponente,
            initloading: false,
            title: '',
            message: '',
        };
    },
    async created() {
        if (!this.validarPermisoComponente('matriz-compatibilidad-almacenamiento')) {
            const id_empresa = await this.obtenerIdEmpresaUsuario();
            this.establecerIdEmpresaFiltro(id_empresa);
            this.obtenerUbicacionesFiltro(id_empresa);
            await this.obtenerComparaciones();
        }
        this.createUsabilityEvents('ingreso_modulo_matriz');
        this.load(false);
    },
    methods: {
        ...mapActions('dashboard', ['validarPermiso', 'obtenerIdEmpresaUsuario']),
        ...mapMutations('dashboard', ['load']),
        ...mapMutations('matrizCompatibilidadAlmacenamiento', [
            'establecerIdEmpresaFiltro',
            'restablecerFiltros',
            'establecerIdUbicacionFiltro',
            'establecerComparaciones'
        ]),
        ...mapActions('matrizCompatibilidadAlmacenamiento', [
            'obtenerComparaciones',
            'obtenerEmpresasFiltro',
            'obtenerUbicacionesFiltro',
            'descargarExcel',
            'eliminarComparacion',
            'descargarExcelGenerico',
        ]),
        ...mapActions("usabilityEvents", ["createUsabilityEvents"]),
        async limpiarFiltro() {
            if(!this.validarPermisoComponente('matriz-compatibilidad-almacenamiento')) {
                this.filtros.id_ubicacion = null;
            } else {
                this.restablecerFiltros();
            }
            await this.obtenerComparaciones();
        },
        async actionDescargarExcel(item) {
            this.title = 'Revisando las últimas actualizaciones de la clasificación de los productos.';
            this.message = 'Estamos revisando y aplicando las actualizaciones de la clasificación SGA de los productos. Verificamos compatibilidad con tus datos actuales y regeneramos la matriz, resaltando las verificaciones faltantes en caso de ser necesario. Este proceso puede durar un momento, por favor espera.';
            this.initloading = true;
            await this.descargarExcel({ comparacion: item, customFieldId: null });
            this.initloading = this.loading;
        },
        async onChangeEmpresa() {
            try {
                this.filtros.id_ubicacion = null;

                if (this.filtros.id_empresa) {
                    await this.obtenerUbicacionesFiltro(this.filtros.id_empresa);
                    await this.obtenerComparaciones();
                } else {
                    await this.obtenerComparaciones();
                }
            } catch (e) {
                // Se ignora el error al obtener ubicaciones o comparaciones
            }
        },
    },
    beforeRouteLeave: function(to, from, next) {
        if (!to.path.includes('matriz-compatibilidad/almacenamiento')) {
            this.reset = true;
        } else {
            this.reset = false;
        }
        next()
    },
    beforeDestroy() {
        if (this.reset) {
            this.restablecerFiltros();
            this.establecerComparaciones({data: []});
        }
    },
    computed: {
        ...mapState('matrizCompatibilidadAlmacenamiento', [
            'comparaciones',
            'empresas_filtro',
            'ubicaciones_filtro',
            'filtros',
            'loading'
        ]),
    }
};
</script>

<style src="../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>

<style>
.el-select-input-group {
    width: 70%;
}

.button-input-group {
    padding: 4px 10px;
    font-size: 13px;
}

.vue-treeselect__no-children-tip {
    display: none;
}
</style>
